
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			// hidden={value !== index}
			id={`full-width-tabpanel-${index}`}
			aria-labelledby={`full-width-tab-${index}`}
			{...other}
		>
            <Box p={1}>{children[value]}</Box>
			{/* {value === index && (
			)} */}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a11yProps(index) {
	return {
		id: `full-width-tab-${index}`,
		'aria-controls': `full-width-tabpanel-${index}`,
	};
}

class TabsContent extends Component {
    state = {
        value: 0,
        index: 0
    }
    handleChange = (e, value) => {
        this.setState({
            value
        })
    };
    handleChangeIndex = (index) => {
        this.setState({
            index
        })
    };

    render() {
        const {value, index} = this.state;
        console.log('====================================');
        console.log(this.props);
        console.log('====================================');
        return (
            <Box >
				<Tabs
					value={value}
					onChange={this.handleChange}
					indicatorColor="primary"
					textColor="primary"
					variant="fullWidth"
					// variant="scrollable"
          			scrollButtons="auto"
				>
					{this.props.labels.map( (label, i) => (
						<Tab label={label} {...a11yProps(i)} key={label} />
					))}
				</Tabs>
				<TabPanel children={this.props.children} value={value} index={index} />
			</Box>
        );
    }
}

export default TabsContent;
